import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function RefCaptureClient() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let done = false;
    (async () => {
      try {
        const { data } = await api.post(`/rc/${code}/visit`);
        localStorage.setItem("tb_cref", code.toUpperCase());
        toast.success(`Vous êtes parrainé par ${data.referrer_name} — profitez d'une réduction sur votre 1re commande !`);
      } catch {
        // invalid code — ignore
      } finally {
        if (!done) navigate("/", { replace: true });
      }
    })();
    return () => { done = true; };
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A] text-white" data-testid="ref-capture-client">
      <p className="text-sm text-slate-300">Redirection en cours…</p>
    </div>
  );
}
